import { render, staticRenderFns } from "./contractPartyJiaConfirm.vue?vue&type=template&id=23631466&scoped=true&"
import script from "./contractPartyJiaConfirm.vue?vue&type=script&lang=js&"
export * from "./contractPartyJiaConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23631466",
  null
  
)

export default component.exports